import * as React from "react";

import GenButton from "../Gen/Button";

import classNames from "classnames";

import axios from "axios";

const INTIALIZING = "INTIALIZING";
const NO_CAMERA = "NO_CAMERA";
const LIVE_CAMERA = "LIVE_CAMERA";
const RECORDING = "RECORDING";
const PLAYING = "PLAYING";

function randomString() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

interface MediaAssetNewMediaRecorderProps {
  document_id: number;
  document_title: string;
}

interface MediaAssetNewMediaRecorderState {
  videoRecorderStatus: "INTIALIZING" | "NO_CAMERA" | "LIVE_CAMERA" | "RECORDING" | "PLAYING";
  audioInputDevices?: Array<MediaDeviceInfo>;
  videoInputDevices?: Array<MediaDeviceInfo>;
  selectedAudioInputDeviceId?: string;
  selectedVideoInputDeviceId?: string;
  facingMode?: string;
  recordedFile?: Blob;
  progressPercent?: number;
}
export default class MediaAssetNewMediaRecorder extends React.Component<MediaAssetNewMediaRecorderProps, MediaAssetNewMediaRecorderState> {
  constructor(props: MediaAssetNewMediaRecorderProps) {
    super(props);

    this.state = {
      videoRecorderStatus: INTIALIZING,
    };
  }

  private stream?: MediaStream;
  private video?: HTMLVideoElement;
  private mediaRecorder?: MediaRecorder;
  private recordedBlobs?: Array<Blob>;

  componentDidMount() {
    this.startStreamByDeviceIds();
  }

  async getDevices() {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();

      this.setState({
        audioInputDevices: devices.filter((device) => device.kind === "audioinput"),
        videoInputDevices: devices.filter((device) => device.kind === "videoinput"),
      });
    } catch (e) {
      console.error("navigator.getUserMedia error:", e);
      this.setState({videoRecorderStatus: NO_CAMERA});
    }
  }

  async startStreamByDeviceIds(audioDeviceId?: string, videoDeviceId?: string) {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => {
        track.stop();
      });
    }

    const constraints = {
      audio: {deviceId: audioDeviceId ? {exact: audioDeviceId} : undefined},
      video: {deviceId: videoDeviceId ? {exact: videoDeviceId} : undefined},
    };

    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);

      this.getDevices();

      this.handleStream(stream);
    } catch (e) {
      console.error("navigator.getUserMedia error:", e);
      this.setState({videoRecorderStatus: NO_CAMERA});
    }
  }

  handleStream(stream: MediaStream) {
    const allTracks = stream.getTracks();

    const audioTrack = allTracks.find((track) => track.kind === "audio");

    const videoTrack = allTracks.find((track) => track.kind === "video");

    if (!videoTrack) { return; }

    const facingMode = videoTrack.getSettings().facingMode;

    this.setState({
      selectedAudioInputDeviceId: audioTrack ? audioTrack.getSettings().deviceId : undefined,
      selectedVideoInputDeviceId: videoTrack ? videoTrack.getSettings().deviceId : undefined,
      videoRecorderStatus: LIVE_CAMERA,
      facingMode: facingMode,
    });

    this.stream = stream;
    if (this.video) {
      this.video.srcObject = stream;
      this.video.autoplay = true;
      this.video.muted = true;
    }
  }


  ///////////////////////
  // CAMERA SELECTION //
  /////////////////////

  // handleAudioInputDeviceChange(e) {
  //   let selectedAudioInputDeviceId = e.target.value
  //   this.setState({selectedAudioInputDeviceId: selectedAudioInputDeviceId}, () => {
  //     this.startStreamByDeviceIds(this.state.selectedAudioInputDeviceId, this.state.selectedVideoInputDeviceId)
  //   })
  // }
  //
  // handleVideoInputDeviceChange(e) {
  //   let selectedVideoInputDeviceId = e.target.value
  //   this.setState({selectedVideoInputDeviceId: selectedVideoInputDeviceId}, () => {
  //     this.startStreamByDeviceIds(this.state.selectedAudioInputDeviceId, this.state.selectedVideoInputDeviceId)
  //   })
  // }

  toggleCamera() {
    const {
      selectedAudioInputDeviceId,
      selectedVideoInputDeviceId,
      videoInputDevices,
    } = this.state;

    if (!videoInputDevices) { return; }

    const currentDeviceIndex = videoInputDevices.findIndex((device) => device.deviceId === selectedVideoInputDeviceId);
    const nextDeviceIndex = (currentDeviceIndex + 1) % videoInputDevices.length;
    const nextDevice = videoInputDevices[nextDeviceIndex];

    this.setState({selectedVideoInputDeviceId: nextDevice.deviceId}, () => {
      this.startStreamByDeviceIds(selectedAudioInputDeviceId, selectedVideoInputDeviceId);
    });
  }

  ////////////////
  // RECORDING //
  //////////////

  startRecording() {
    this.setState({recordedFile: undefined});
    this.recordedBlobs = [];

    // let options = {mimeType: 'video/webm;codecs=vp9'}
    let options = {mimeType: "video/webm"};

    if (!MediaRecorder.isTypeSupported(options.mimeType)) {
      console.error(`${options.mimeType} is not Supported`);
      options = {mimeType: "video/webm;codecs=vp8"};
      if (!MediaRecorder.isTypeSupported(options.mimeType)) {
        console.error(`${options.mimeType} is not Supported`);
        options = {mimeType: "video/webm"};
        if (!MediaRecorder.isTypeSupported(options.mimeType)) {
          console.error(`${options.mimeType} is not Supported`);
          options = {mimeType: ""};
        }
      }
    }

    if (!this.stream) { return; }

    try {
      this.mediaRecorder = new MediaRecorder(this.stream, options);
    } catch (e) {
      console.error("Exception while creating MediaRecorder:", e);
      return;
    }


    this.mediaRecorder.onstop = this.onRecordingStop.bind(this);
    this.mediaRecorder.ondataavailable = this.handleMediaRecorderData.bind(this);
    this.mediaRecorder.start(1000);

    this.setState({videoRecorderStatus: RECORDING});
  }

  onRecordingStop() {
    const blob = new Blob(this.recordedBlobs, {type: "video/webm"});
    this.setState({recordedFile: blob});

    if (!this.video) { return; }

    this.video.srcObject = null;
    this.video.src = window.URL.createObjectURL(blob);
    this.video.autoplay = false;
    this.video.muted = false;
    this.video.onended = this.stopPlayRecording.bind(this);
  }

  handleMediaRecorderData(event: BlobEvent) {
    if (event.data && event.data.size > 0 && this.recordedBlobs) {
      this.recordedBlobs.push(event.data);
    }
  }

  stopRecording() {
    console.log("Stop Recording");
    this.mediaRecorder?.stop();
    this.setState({videoRecorderStatus: LIVE_CAMERA});
  }

  discardRecording() {
    this.setState({recordedFile: undefined});

    if (!this.video) { return; }

    this.video.srcObject = null;
    this.video.srcObject = this.stream || null;
    this.video.autoplay = true;
    this.video.muted = true;
    this.video.onended = null;
  }

  ///////////////
  // PLAYBACK //
  /////////////

  playRecording() {
    if (!this.video) { return; }

    this.video.play();
    this.setState({videoRecorderStatus: PLAYING});
  }

  stopPlayRecording() {
    if (!this.video) { return; }

    this.video.pause();
    this.video.currentTime = 0;
    this.setState({videoRecorderStatus: LIVE_CAMERA});
  }


  ////////////////
  // UPLOADING //
  //////////////
  async upload() {
    console.log(this.state.recordedFile);

    if (!this.state.recordedFile) { return; }

    const randomUploadFileName = `${randomString()}.webm`;

    let signedUrl;
    try {
      signedUrl = await axios({
        method: "get",
        url: "/media_assets/signed_url",
        params: {
          objectName: randomUploadFileName,
          path: "/uploads/",
        },
        headers: {
          Accept: "application/json",
        },
        responseType: "json",
      });
      signedUrl = signedUrl.data.signedUrl;
    } catch (e) {
      console.error("ERROR GET SIGNED URL:", e);
    }

    console.log("SIGNED URL:", signedUrl);

    const file = new File([this.state.recordedFile], randomUploadFileName);

    let uploadResponse;
    try {
      uploadResponse = await axios.put(signedUrl, file, {
        headers: {
          "Content-Type": file.type,
        },
        onUploadProgress: (progressEvent) => this.setState({progressPercent: progressEvent.total ? progressEvent.loaded/progressEvent.total * 100 : 0}),
      });
    } catch (e) {
      console.error("ERROR UPLOAD:", e);
    }

    console.log("UPLOAD RESPONSE:", uploadResponse);

    this.onUploadFinish(signedUrl);
  }

  onUploadProgress(progressEvent: ProgressEvent) {
    this.setState({progressPercent: progressEvent.loaded/progressEvent.total * 100});
  }

  onUploadFinish(fileURL: string) {
    console.log("FINISH:", fileURL);

    const fileUrl = new URL(fileURL);
    const originalPath = fileUrl.pathname;

    console.log("Response:", fileURL);
    console.log("File Path:", originalPath);

    const csrfToken = (document.querySelector("[name=csrf-token]") as HTMLMetaElement).content;
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;

    axios.post(`/documents/${this.props.document_id}/media_assets`, {
      media_asset: {
        original_upload_path: originalPath,
        media_type: "video",
      },
    })
    .then((response) => {
      Turbo.visit(`/documents/${this.props.document_id}/hipaa_releases/new`);
    })
    .catch((error) => {
      console.log(error);
      alert("Error Uploading:");
    });
  }

  render() {
    let controls = null;
    switch (this.state.videoRecorderStatus) {
      case INTIALIZING:
        controls = (
          <h5>Connecting to camera...</h5>
        );

        break;
      case LIVE_CAMERA:
      case RECORDING:
      case PLAYING:
        if (typeof this.state.progressPercent === "number") {
          controls = (
            <div className="progress progress-striped active">
              <div className="bar" style={{width: `${this.state.progressPercent * 0.95}%`}} />
            </div>
          );
        } else if (this.state.recordedFile) {
          const isPlaying = this.state.videoRecorderStatus === PLAYING;

          controls = (
            <>
              <GenButton
                name={<span><i className="fa fa-trash fa-2x" /><br/>Discard</span>}
                highlighted
                disabled={isPlaying}
                onClick={this.discardRecording.bind(this)}
              />
              <GenButton
                name={<span><i className={`fa ${isPlaying ? "fa-circle-stop" : "fa-circle-play"} fa-4x`} /><br/>{isPlaying ? "Stop" : "Play"}</span>}
                highlighted
                onClick={isPlaying ? this.stopPlayRecording.bind(this) : this.playRecording.bind(this)}
              />
              <GenButton
                name={<span><i className="fa fa-upload fa-2x" /><br/>Upload</span>}
                highlighted
                disabled={isPlaying}
                onClick={this.upload.bind(this)}
              />
            </>
          );
        } else {
          // let audioInputSelectList
          // if (this.state.audioInputDevices) {
          //   audioInputSelectList = <div>
          //     <select value={this.state.selectedAudioInputDeviceId} onChange={this.handleAudioInputDeviceChange.bind(this)}>
          //       {this.state.audioInputDevices.map(audioInputDevice => <option key={audioInputDevice.deviceId} value={audioInputDevice.deviceId}>
          //         {audioInputDevice.label}
          //       </option>)}
          //     </select>
          //   </div>
          // }
          //
          // let videoInputSelectList
          // if (this.state.videoInputDevices) {
          //   videoInputSelectList = <div>
          //     <select value={this.state.selectedVideoInputDeviceId} onChange={this.handleVideoInputDeviceChange.bind(this)} disabled={this.state.videoRecorderStatus === RECORDING}>
          //       {this.state.videoInputDevices.map(videoInputDevice => <option key={videoInputDevice.deviceId} value={videoInputDevice.deviceId}>
          //         {videoInputDevice.label}
          //       </option>)}
          //     </select>
          //   </div>
          // }

          const isRecording = this.state.videoRecorderStatus === RECORDING;
          const shouldShowCameraToggle = this.state.videoInputDevices; // && this.state.videoInputDevices.length > 1

          controls = (
            <>
              <div className='gen-empty-flex-space' />
              <GenButton
                name={<span><i className={`fa ${isRecording ? "fa-circle-stop" : "fa-circle"} fa-4x`} /><br/>{isRecording ? "Stop" : "Record"}</span>}
                highlighted
                onClick={isRecording ? this.stopRecording.bind(this) : this.startRecording.bind(this)}
              />
              {shouldShowCameraToggle ? (
                <GenButton
                  name={<span><i className="fa fa-camera fa-2x" /><br/>Switch</span>}
                  highlighted
                  disabled={isRecording}
                  onClick={this.toggleCamera.bind(this)}
                />
              ) : (
                <div className='gen-empty-flex-space' />
              )}
            </>
          );
        }

        break;
      case NO_CAMERA:
        controls = (
          <div className="error">
            <p>Error Accessing Camera</p>
          </div>
        );

        break;
      default:
        controls = (
          <div className="error">
            <p>Error</p>
          </div>
        );
    }

    return (
      <div className='media-asset-new-media-recorder'>
        <video
          className={classNames({mirror: !this.state.facingMode || this.state.facingMode === "user"})}
          ref={(video) => {if (video) {this.video = video;}}}
        />
        <div className='controls-box'>
          <div className='controls-inner-box'>
            <div className='controls-title'>
              <h6>Patient Capture -- {this.props.document_id} | {this.props.document_title}</h6>
            </div>
            <div className='controls'>
              {controls}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
